<div mat-dialog-title class="cust-modal-title">
    <h2 class="m-0">{{ parentData.title }}</h2>
    <button mat-icon-button mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <mat-dialog-content>
   
    <div style="display: flex; justify-content: center; align-items: center">
      <mat-spinner [diameter]="20" *ngIf="loader"></mat-spinner>
    </div>
  
    <mat-chip-listbox
      style="display: flex; flex-wrap: wrap; width: 400px"
      aria-label="Fish selection"
      class="mb-2"
      *ngIf="!loader"
    >
      <mat-chip
        color="primary"
        selected
        *ngFor="let asset of assetList; let i = index"
        [removable]="removable"
        (removed)="removeAsset(i)"
       
        >{{ asset?.assetName }}
        <mat-icon matChipRemove *ngIf="removable">cancel</mat-icon></mat-chip
      >
    </mat-chip-listbox>
    <div class="upload-group mb-2">
      <label for="formFile" class="form-label">Upload media</label>
      <div class="file-input-wrap">
        <div class="custom-input-label">
          <mat-icon class="material-icons-outlined" class="mb-1" color="primary"
            >backup</mat-icon
          >
          <p>Drop your file(s) here or <span>browse</span></p>
        </div>
        <input
          class="form-control"
          id="formFile" 
          accept="image/*, video/*"
          type="file"
          multiple
          (change)="onUploadImage($event)"
        />
      </div>
    </div>
  </mat-dialog-content>
  
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close>Cancel</button>
    <button
      mat-flat-button
      color="accent"
      [disabled]="
        assetList.length === 0
      "
      (click)="onPost()"
    >
      {{ editMode ? "Edit" : "Save" }}
    </button>
  </mat-dialog-actions>
  